<template>
  <div class="new-main-right">
    <transition name="fadeleft">
      <router-view :key="getKey()"></router-view>
    </transition>
  </div>
</template>
<script>
import qs from 'qs';
export default {
  data() {
    return {

    }
  },
  methods: {
    getKey() {
      return qs.stringify(this.$route.query)
    }
  }
}
</script>
<style lang="scss" scoped>
.new-main-right{
  height: 100%;
  flex: 1;
  overflow-x: hidden;
}
</style>
